// extracted by mini-css-extract-plugin
module.exports = {"containerSidebar":"container-sidebar_containerSidebar__b74SW","main":"container-sidebar_main__DeTxx"};